import { path } from "../../api";
import { restClient } from "../../utils/restClient";

export default {
  namespaced: true,
  name: "responsibleGaming",
  state: {},
  mutations: {},
  actions: {
    async setLimits(_, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.client.responsibleGaming.setLimits,
            "POST",
            payload
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getLimits() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await restClient(
            path.client.responsibleGaming.getLimits,
            "GET"
          );
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
    async setAutoExclusion(_, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.client.responsibleGaming.setExclusion,
            "POST",
            payload
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async removeConfig(_, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await restClient(
            path.admin.responsibleGaming.remove,
            "POST",
            payload
          );
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
